import styled from "styled-components";

export const TabsNavigationListContainerDefaultBox = styled.nav<{shouldAppear: boolean}>`
    background-color: ${props => props.theme.colors.backgroundDark};
    width: 100%;
    max-height: ${props => props.shouldAppear ? '5rem' : 0};
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;

    transition: max-height 0.3s ease;

    &::-webkit-scrollbar {
        display: none;
    }
`;
